
import { Component, Vue, Ref } from 'vue-property-decorator'
import { PersonService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import KeywordDialog from '@/components/keyword_dialog/index.vue'
import FullLoading from '@/components/full_loading/index.vue'

const Status = {
    Not_Examine: 1,
    Pass: 2,
    Fail: 3
}

@Component({
    name: 'keyword-examine',
    components: {
        ScrollTo,
        KeywordDialog,
        FullLoading
    }
})
export default class TagExamine extends Vue {
    @Ref('scrollRef') readonly scrollEl!: ScrollToType
    @Ref('keywordDialogRef') readonly keywordDialog: any
    private keywordList = []
    private pageIndex = 1
    private pageSize = 15
    private status = -1
    private pageTotal = 0
    private examineList = [
        { value: -1, label: '所有记录' },
        { value: Status.Not_Examine, label: '待审核' },
        { value: Status.Pass, label: '已通过' },
        { value: Status.Fail, label: '不通过' }
    ]
    private isLoading = false
    private loadingText = ''
    private curKeywors: any[] = []
    
    private mounted() {
        this.getkeywordList()
    }

    /** 获取标签列表 */ 
    private async getkeywordList() {
        this.showLoading()
        const status = this.status > -1 ? this.status : undefined
        const params = {
            status: status,
            page_index: this.pageIndex,
            pageSize: this.pageSize
        }
        const result = await PersonService.getKeywordFromUser(params)
        this.hideLoading()
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.keywordList = result.data.list
        }
    }

    private reset() {
        this.pageIndex = 1
        this.pageTotal = 0
    }

    private onCurrentChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getkeywordList)
    }

    private onExamineChange(status: number) {
        this.status = status
        this.reset()
        this.getkeywordList()
    }

    private async onDetalStatusChange(status: number, recored: any) {
        const params = {
            id: recored.id,
            status
        }
        const result = await PersonService.updateKeywordStatus(params)
        if (result.status === 200) {
            recored.status = status
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            return
        }
        return this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    // 显示所有关键词
    private onShowKeywordDialog(keywords: any[]) {
        this.curKeywors = keywords
        this.keywordDialog.show()
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
